import Breadcrumbs from 'components/atomic/Breadcrumbs'
import Error from 'next/error'
import MetaSeo from 'components/atomic/MetaSeo'
import { DISCIPLINE, SLUG } from 'utils/endpoint'
import { api, CAS_DOMAIN } from 'utils'
import ListingAlgolia from 'components/ListingAlgolia'
import { useRouter } from 'next/router'
import Head from 'next/head'

const RisorseDisciplina = ({ disciplina, pagina, statusCode }) => {
  if (!pagina) return <Error statusCode={statusCode} />

  const background = disciplina.color
    ? { backgroundColor: `#${disciplina.color}` }
    : { backgroundColor: `black` }

  const filtriInitial = [disciplina.valore_attributo]

  const filtriDisponibili = [
    'visibilita', // custom
    'Ordine di scuola',
    'Classe',
    'Eta',
    'models', // custom
    'Tipo Strumento',
  ]

  const router = useRouter()
  const canonical = router.asPath.split('?')[0]

  return (
    <>
      {pagina ? (
        <>
          <MetaSeo seo={pagina.seo} />
          <Head>
            <link rel="canonical" href={CAS_DOMAIN + canonical} />
          </Head>
          <main className="listing-page">
            <div
              className="w-container-fluid u-before-section u-background-image"
              style={background}
            >
              <div className="w-container">
                <Breadcrumbs breadcrumbs={pagina.breadcrumbs} />
              </div>

              <section className="listing-page__header">
                <div className="w-container">
                  <h1 className="listing-page__title">Risorse {disciplina.titolo}</h1>
                </div>
              </section>
            </div>
            <section className="listing-page__list-section section">
              <ListingAlgolia filtriInitial={filtriInitial} filtriDisponibili={filtriDisponibili} />
            </section>
          </main>
        </>
      ) : null}
    </>
  )
}

export async function getStaticPaths() {
  const response = await api.get(DISCIPLINE)
  const discipline = response.data

  const paths = discipline
    .map((d) => ({
      params: { slug: d.slug },
    }))
    .slice(0, 1)

  return {
    paths,
    fallback: 'blocking',
  }
}

export const getStaticProps = async ({ params: { slug } }) => {
  try {
    const response = await api.get(`${DISCIPLINE}${SLUG}${slug}/`)

    const disciplina = response.data

    const pagina = disciplina.pagina

    const toolbarProps = { toolbarPage: pagina }

    return {
      props: { disciplina, pagina, ...toolbarProps, key: disciplina.id },
      revalidate: 60 * 2,
    }
  } catch (error) {
    console.log(error)
    return {
      notFound: true,
    }
  }
}

export default RisorseDisciplina
